import { createActionGroup, props } from '@ngrx/store';
import { AnalyticEvent } from '../../entity/analytics/analytic-tracking';
import { AnalyticsCategory } from '../../entity/analytics/analytics-categories';

type AnalyticEventWithoutCategory = Omit<AnalyticEvent, 'category'>;

type EventsFromAnalyticCategory = {
  [key in keyof typeof AnalyticsCategory as `Track ${(typeof AnalyticsCategory)[key]} Event`]: (
    props: AnalyticEventWithoutCategory,
  ) => AnalyticEvent;
};

// Dynamically create actions for each analytics category defined in AnalyticsCategory enum to avoid repetitive code.
// This will generate events like 'Track Accounting Event', 'Track Clients Event', etc. and then functions will be like 'trackAccountingEvent', 'trackClientsEvent', etc.
const eventsFromAnalyticCategory = Object.values(AnalyticsCategory)
  .map((category) => ({ key: `Track ${category} Event`, value: category }))
  .reduce((acc, curr) => {
    acc[curr.key] = (props: AnalyticEventWithoutCategory) => ({
      category: curr.value,
      ...props,
    });
    return acc;
  }, {} as EventsFromAnalyticCategory);

export const AnalyticActions = createActionGroup({
  source: 'Analytic',
  events: {
    'Track Event': props<AnalyticEvent>(),
    ...eventsFromAnalyticCategory,
  },
});

export const AllAnalyticActions = Object.values(AnalyticActions);
